import { CURRENT_VERSION, DEFAULT_LAYERS } from "../constants";
import { migrateToV3 } from "./V3Migrator";

const getCurrentData = (data, storageData) => {
    return storageData
        && storageData.timestamp
        && storageData.timestamp > data.timestamp
        ? storageData
        : data;
}

const migrate = (data, storageData = null) => {
    if (!data) {
        return {
            layers: DEFAULT_LAYERS,
        };
    }
    let currentData = getCurrentData(data, storageData);
    return currentData.version === CURRENT_VERSION
        ? currentData
        : migrateToV3(currentData, data);
}

export { migrate };
